<h1 mat-dialog-title>Disable user?</h1>
<mat-dialog-content>
  <p>{{ data.email }} will no longer be able to sign in.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="warn" (click)="onConfirm()">Disable</button>
</mat-dialog-actions>
